/**
 * Axios 实例配置
 * 包含请求拦截器（添加JWT）和响应拦截器（错误处理）
 */

import axios, { AxiosError, InternalAxiosRequestConfig } from 'axios';
import { config } from '../config';
import { ApiResponse } from '../types';

const instance = axios.create({
  baseURL: config.apiBaseUrl,
  timeout: config.timeout,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 请求拦截器：自动添加 JWT Token
instance.interceptors.request.use(
  (req: InternalAxiosRequestConfig) => {
    const token = localStorage.getItem('token');
    if (token && req.headers) {
      req.headers.Authorization = `Bearer ${token}`;
    }
    return req;
  },
  (error) => Promise.reject(error)
);

// 响应拦截器：统一处理响应和错误
instance.interceptors.response.use(
  (response) => {
    const data = response.data as ApiResponse<unknown>;
    if (data.code !== 0) {
      return Promise.reject(new Error(data.message || '请求失败'));
    }
    return response.data;
  },
  (error: AxiosError<{ code?: number; message?: string; detail?: { code?: number; message?: string } }>) => {
    // 401 未授权，清除token
    if (error.response?.status === 401) {
      localStorage.removeItem('token');

      // 返回带有错误码的响应对象，让调用方可以处理
      const detail = error.response.data?.detail;
      return Promise.resolve({
        code: detail?.code || 40101,
        message: detail?.message || '登录失败，请检查手机号和姓名是否匹配',
        data: null,
      });
    }

    let message = '网络错误，请稍后重试';

    if (error.response) {
      const { status, data } = error.response;
      message = data?.detail?.message || data?.message || `请求失败 (${status})`;
    } else if (error.request) {
      message = '无法连接到服务器';
    }

    return Promise.reject(new Error(message));
  }
);

export default instance;
